const images = {
  loginBackground: '/images/login_bg.jpg',
  welcomeBackground: '/images/welcome_bg.jpg',
};

export default images;
